<template>
  <button :class="buttonClass" :disabled="disabled" :title="title">
    <span v-if="icon" :class="iconClass" />
    <slot name="icon" />
    <span v-if="text" :class="{ 'btn-text-mobile-hidden': hideTextMobile }">{{ text }}</span>
    <slot />
  </button>
</template>

<script>
// buttons are: add, edit, save, delete, cancel, tab, neutral, white, gray, and visitor-themed primary, secondary, outline
//   transparent variants (tinted bg at rest, solid on hover): transparent-action, transparent-warn, transparent-danger
// sizes: add class 'button-medium' or 'button-small' (default is large)
// icons are defined in icons.css: add, edit, delete, save, cancel, confirm, cart, contact, back, decrease, uparrow, downarrow, updownarrow, filter, upload, user, search, hide, show, colors, grid, image, expand, revert
// icon: a class icon from icons.css; or pass an inline SVG component in the #icon slot to follow the text color
export default {
  props: {
    button: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    hideTextMobile: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass() {
      return [
        this.button + '-button',
        { 'button-w-icon': this.icon || this.$slots.icon },
        { 'btn-icon-only-mobile': this.hideTextMobile }
      ]
    },
    iconClass() {
      return ['icon', this.icon + '-icon']
    }
  }
}
</script>
